'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lodash = require('lodash');

const SPACING_ATTRIBUTES = new Set(['padding', 'margin']);
const BORDER_WIDTH_ATTRIBUTES = new Set([
    'border-width',
    'border-top-width',
    'border-right-width',
    'border-bottom-width',
    'border-left-width'
]);
const BORDER_RADIUS_ATTRIBUTES = new Set(['border-radius']);
const cssNameToJsName = (name) => {
    const split = name.split('-');
    let output = '';
    for (let i = 0; i < split.length; i++) {
        if (i > 0 && split[i].length > 0 && !(i == 1 && split[i] == 'ms')) {
            split[i] = split[i].substring(0, 1).toUpperCase() + split[i].substring(1);
        }
        output += split[i];
    }
    return output;
};
const fontFaceStyleSources = (sources) => {
    const formattedSources = sources.map(s => `url('${s.url}') format('${s.format}')`);
    return formattedSources.join(',');
};
const fontFaceStyle = (name, sources, fontWeight = 'normal', fontStyle = 'normal') => `
  @font-face {
    font-family: ${name};
    font-style: ${fontStyle};
    font-display: swap;
    font-weight: ${fontWeight};
    src: ${fontFaceStyleSources(sources)};
  }
`;
const calculatePixelValue = (base, value) => {
    let result = value * base;
    if (isNaN(result) || result == 0) {
        return 0;
    }
    return `${result}px`;
};
const getBaseValue = (attribute, options) => {
    var _a, _b, _c;
    const firstWord = attribute.name.split('-')[0];
    const useSpacing = SPACING_ATTRIBUTES.has(firstWord);
    const isBorderWidthProperty = BORDER_WIDTH_ATTRIBUTES.has(attribute.name);
    const isBorderRadiusProperty = BORDER_RADIUS_ATTRIBUTES.has(attribute.name);
    if (!lodash.isNumber(attribute.transformedValue)) {
        return null;
    }
    if (useSpacing) {
        return (_a = options === null || options === void 0 ? void 0 : options.spacing) !== null && _a !== void 0 ? _a : 8;
    }
    else if (isBorderWidthProperty) {
        return (_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 1;
    }
    else if (isBorderRadiusProperty) {
        return (_c = options === null || options === void 0 ? void 0 : options.borderRadius) !== null && _c !== void 0 ? _c : 1;
    }
    return null;
};
const transformRules = (themeBreakpoints, brandStyle, options) => {
    const attributesByDevice = brandStyle.attributes.reduce((styles, attribute) => {
        const cssInJsAttributeName = cssNameToJsName(attribute.name);
        const devices = new Set(attribute.devices);
        let attributeValue = attribute.transformedValue;
        const baseValue = getBaseValue(attribute, options);
        if (baseValue !== null) {
            attributeValue = calculatePixelValue(baseValue, attributeValue);
        }
        if (devices.size == 0) {
            styles.all[cssInJsAttributeName] = attributeValue;
        }
        if (devices.has('mobile')) {
            styles.mobile[cssInJsAttributeName] = attributeValue;
        }
        if (devices.has('desktop')) {
            styles.desktop[cssInJsAttributeName] = attributeValue;
        }
        return styles;
    }, { all: {}, desktop: {}, mobile: {} });
    const rules = attributesByDevice.all;
    if (Object.keys(attributesByDevice.mobile).length > 0) {
        rules[themeBreakpoints.down('md')] = attributesByDevice.mobile;
    }
    if (Object.keys(attributesByDevice.desktop).length > 0) {
        rules[themeBreakpoints.up('md')] = attributesByDevice.desktop;
    }
    return rules;
};
const transformBrandStyle = (themeBreakpoints, brandStyles, transformationOptions) => {
    return brandStyles.reduce((styles, brandStyle) => {
        const rules = transformRules(themeBreakpoints, brandStyle, transformationOptions);
        switch (brandStyle.targetIdentifier) {
            case 'p':
                styles['body1'] = rules;
                break;
            default:
                styles[brandStyle.targetIdentifier] = rules;
        }
        return styles;
    }, {});
};
const getStylesForTarget = (theme, target) => {
    const brandStyles = theme.brandStyles;
    const targetStyles = brandStyles.find(bs => bs.targetIdentifier === target);
    const hoverTargetStyles = brandStyles.find(bs => bs.targetIdentifier === `${target}:hover`);
    const transformationOptions = {
        spacing: theme.baseAttributes.padding,
        borderWidth: theme.baseAttributes.borderWidth,
        borderRadius: theme.baseAttributes.borderRadius
    };
    if (!targetStyles) {
        return null;
    }
    const rules = transformRules(theme.breakpoints, targetStyles, transformationOptions);
    if (hoverTargetStyles) {
        rules['&:hover'] = transformRules(theme.breakpoints, hoverTargetStyles, transformationOptions);
    }
    return rules;
};

exports.calculatePixelValue = calculatePixelValue;
exports.cssNameToJsName = cssNameToJsName;
exports.fontFaceStyle = fontFaceStyle;
exports.fontFaceStyleSources = fontFaceStyleSources;
exports.getBaseValue = getBaseValue;
exports.getStylesForTarget = getStylesForTarget;
exports.transformBrandStyle = transformBrandStyle;
exports.transformRules = transformRules;
//# sourceMappingURL=theme.js.map
